import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom';
import ViewDetails from '../leads/ViewDetails';
import ViewServiceReq from './ViewServiceReq';
import HospitalPreview from './HospitalPreview';
import CompanyPreview from './CompanyPreview';
import EventPreview from './EventPreview';
import EditHospitalProfile from './EditHospitalProfile';
import EditCompany from './EditCompany';
import EditEvent from './EditEvent';



// Lazy load components
const AddUser = lazy(() => import('../leads/AddUser'));
const ViewUser = lazy(() => import('../leads/ViewUsers'));
const LeadsModule = () => {
  return (
    <Suspense fallback={null}>
       <Routes>
        <Route path="addUser" element={<AddUser />} />
        <Route path="ViewUser" element={<ViewUser />} />
        <Route path="declinedUsers" element={<ViewUser />} />
        <Route path="ViewDetails" element={<ViewDetails />} />
        <Route path="ViewUser/viewServiceReq" element={<ViewServiceReq />} />
        <Route path="ViewUser/previewHospital" element={<HospitalPreview />} />
        <Route path="ViewUser/previewCompany" element={<CompanyPreview />} />
        <Route path="ViewUser/eventPreview" element={<EventPreview />} />
        <Route path="ViewUser/editHospitals" element={<EditHospitalProfile />} />
        <Route path="ViewUser/editCompany" element={<EditCompany />} />
        <Route path="ViewUser/editEvent" element={<EditEvent />} />
      </Routes>
    </Suspense>
  );
};

export default LeadsModule
